import React, {ReactElement, useEffect} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import services from '../../api/remoteServices';
import {useFetchUserQuery} from '../../api/userApi';
import './index.scss';

interface LoginWrapperProps {
  children: React.ReactNode;
  height?: 'minimal' | 'full';
}

const LoginWrapper = ({children, height}: LoginWrapperProps): ReactElement => {
  const {error, isSuccess} = useFetchUserQuery();
  const heightClass = height === 'minimal' ? 'min-height' : 'full-height';

  useEffect(() => {
    if (
      error &&
      typeof error === 'object' &&
      'status' in error &&
      error.status === 401
    ) {
      const redirectUrl = encodeURI(window.location.href);
      window.location.href = `${services.stores}/stores/new?redirect_url=${redirectUrl}`;
    }
  }, [error]);

  const progress: ReactElement = (
    <div className="login-wrapper">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={heightClass}>
        <CircularProgress />
      </Grid>
    </div>
  );

  return isSuccess ? <>{children}</> : <>{progress}</>;
};

LoginWrapper.defaultProps = {
  height: 'full'
};

export default LoginWrapper;
